var map = {
	"./black-brush-theme.json": 8803,
	"./black-paint-theme.json": 1291,
	"./black-swirl-theme.json": 2556,
	"./black-wave-theme.json": 2684,
	"./blue-brush-theme.json": 2938,
	"./blue-paint-theme.json": 7174,
	"./blue-swirl-theme.json": 449,
	"./blue-wave-theme.json": 583,
	"./dblue-brush-theme.json": 8040,
	"./dblue-paint-theme.json": 2140,
	"./dblue-swirl-theme.json": 7847,
	"./dblue-wave-theme.json": 2877,
	"./default-theme.json": 5020,
	"./green-brush-theme.json": 5283,
	"./green-paint-theme.json": 4027,
	"./green-swirl-theme.json": 9052,
	"./green-wave-theme.json": 6172,
	"./orange-brush-theme.json": 5980,
	"./orange-paint-theme.json": 2856,
	"./orange-swirl-theme.json": 4659,
	"./orange-wave-theme.json": 1657,
	"./primary-theme.json": 9747,
	"./purple-brush-theme.json": 9116,
	"./purple-paint-theme.json": 8408,
	"./purple-swirl-theme.json": 2099,
	"./purple-wave-theme.json": 1913,
	"./red-brush-theme.json": 4835,
	"./red-paint-theme.json": 6635,
	"./red-swirl-theme.json": 9420,
	"./red-wave-theme.json": 8284,
	"./white-brush-theme.json": 8141,
	"./white-paint-theme.json": 8173,
	"./white-swirl-theme.json": 2038,
	"./white-wave-theme.json": 5838,
	"./yellow-brush-theme.json": 2090,
	"./yellow-paint-theme.json": 1510,
	"./yellow-swirl-theme.json": 2529,
	"./yellow-wave-theme.json": 2935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5136;